import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressionStateType } from '../../../interfaces';

@Component({
  selector: 'shared-arrow-line',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './arrow-line.component.html',
  styleUrl: './arrow-line.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowLineComponent {
  state = input.required<ProgressionStateType>();

  readonly ProgressionStateTypeEnum = ProgressionStateType;
}
